import axios from 'axios';
import {
  SESSION_REPLACED_FLAG,
  clearSession,
  handleSessionReplaced,
  redirectToLogin,
} from './session';
import { refreshAccessToken } from './tokenRefresh';

const API_URL = window.__ENV__?.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:20002';

const client = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const url: string = original?.url || '';
    const isAuthEndpoint =
      url.includes('/api/v1/auth/login') ||
      url.includes('/api/v1/auth/register') ||
      url.includes('/api/v1/auth/refresh');

    // ISS-062 — SESSION_REPLACED 는 refresh 로 복구 불가. 즉시 forced logout 흐름.
    const errorCode = (error.response?.data as { error_code?: string } | undefined)?.error_code;
    if (errorCode === 'SESSION_REPLACED') {
      handleSessionReplaced();
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !original._retry && !isAuthEndpoint) {
      original._retry = true;
      try {
        // ISS-069 — 공유 refresh (뮤텍스). 동시 401 다발이어도 /auth/refresh 는 1회만 발생.
        const accessToken = await refreshAccessToken();
        if (original.headers) original.headers.Authorization = `Bearer ${accessToken}`;
        return client(original);
      } catch (refreshError: unknown) {
        const msg =
          (axios.isAxiosError(refreshError) &&
            (refreshError.response?.data as { error?: string })?.error) ||
          '세션이 만료되어 재로그인이 필요합니다';
        clearSession();
        redirectToLogin(msg);
      }
    }
    return Promise.reject(error);
  }
);

export { SESSION_REPLACED_FLAG };
export default client;
